export default (appointmentId, form) => {
  const promise = new Promise((resolve, reject) => {
    form
      .patch(`${process.env.VUE_APP_API_ADMIN_LOCATION}appointments/${appointmentId}`)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
